"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindAccountStrategyEnum = void 0;
var FindAccountStrategyEnum;
(function (FindAccountStrategyEnum) {
  /**
   * Поиск строго по id
   * required: IFindAccountsFilter.id
   */
  FindAccountStrategyEnum["id"] = "id";
  /**
   * Пользователи в школе
   * required: IFindAccountsFilter.school_id
   * optional: IFindAccountsFilter.school_roles
   */
  FindAccountStrategyEnum["school"] = "school";
  /**
   * Мои преподаватели - те, кто проводил уроки (митинги) для меня или указанного ученика
   *
   * @see IFindAccountMyTeachersFilter
   */
  FindAccountStrategyEnum["my_teachers"] = "my_teachers";
  /**
   * Мои ученики - те, для кого проводил уроки (митинги) я или указанный преподаватель
   *
   * @see IFindAccountMyStudentsFilter
   */
  FindAccountStrategyEnum["my_students"] = "my_students";
  /** Добавленные в избранное */
  FindAccountStrategyEnum["favorites"] = "favorites";
  /**
   * Все с кем я контактовал
   *
   * @deprecated слишком широкое понятие и странная реализация
   */
  FindAccountStrategyEnum["contacted"] = "contacted";
  /** Подписчики */
  FindAccountStrategyEnum["subscribers"] = "subscribers";
  /** Подписки */
  FindAccountStrategyEnum["subscriptions"] = "subscriptions";
  /** Пользователи с статусом репетитора/преподавателя */
  FindAccountStrategyEnum["teachers"] = "teachers";
})(FindAccountStrategyEnum = exports.FindAccountStrategyEnum || (exports.FindAccountStrategyEnum = {}));
